(function () {
  'use strict';
  var ouvrir = document.getElementById('pdp-metal-open');
  var dialogue = document.getElementById('pdp-metal-viewer');
  var source = document.getElementById('pdp-support');
  if (!ouvrir || !dialogue || !source || typeof dialogue.showModal !== 'function') return;
  // Le dialogue quitte le formulaire et les ancêtres transformés de la galerie.
  document.body.appendChild(dialogue);
  var toile = dialogue.querySelector('canvas');
  var enveloppe = toile.parentElement;
  var stage = dialogue.querySelector('.metal-viewer__stage');
  var repli = dialogue.querySelector('img');
  var charge = dialogue.querySelector('[data-metal-loading]');
  var erreur = dialogue.querySelector('[data-metal-error]');
  var controles = dialogue.querySelectorAll('[data-metal-turn], [data-metal-reset]');
  var montage = dialogue.querySelector('[data-metal-mount]');
  var vueMontage = montage.querySelector('.metal-mount__viewport');
  var imageMontage = montage.querySelector('.metal-mount__art');
  var toileMontage = montage.querySelector('canvas');
  var assemblage = montage.querySelector('.metal-mount__assembly');
  var commandesArt = dialogue.querySelector('[data-metal-art-controls]');
  var commandesMontage = dialogue.querySelector('[data-metal-mount-controls]');
  var angle = dialogue.querySelector('[data-metal-angle]');
  var mode = 'mount', etape = 0, mx = -8, my = 48, priseMontage = null;
  var sceneMontage = null, trameMontage = 0, finMouvement = 0;
  var pretCourant = false, echecCourant = false;
  var scene = null, focusAvant = null, defilement = 0, corpsAvant = null, delai = 0;
  var clesCorps = ['position', 'top', 'left', 'width', 'overflow'];

  function etat(pret, echec) {
    pretCourant = pret;
    echecCourant = echec;
    enveloppe.hidden = !pret || mode !== 'art';
    repli.hidden = pret || mode !== 'art';
    charge.hidden = pret || echec || mode !== 'art';
    erreur.hidden = !echec || mode !== 'art';
    stage.setAttribute('aria-busy', String(!pret && !echec && mode === 'art'));
    controles.forEach(function (b) { b.disabled = !pret; });
    if (pret || echec) clearTimeout(delai);
  }

  function cadrerMontage() {
    if (mode !== 'mount' || !dialogue.open) return;
    var ratio = parseFloat(source.dataset.ratio) || 0.6923;
    var ecart = Math.max(.84, ratio * .88 + .24);
    var largeur = Math.hypot(ratio * 1.18, ecart) * 1.2 + .12;
    var h = Math.max(30, Math.min((stage.clientWidth - 46) / largeur, (stage.clientHeight - 100) / 1.42, 360));
    montage.style.setProperty('--plate-h', h + 'px');
    montage.style.setProperty('--plate-w', h * ratio + 'px');
    montage.style.setProperty('--mount-gap', h * ecart + 'px');
  }

  function eclairerMontage() {
    trameMontage = 0;
    if (!sceneMontage || !dialogue.open || mode !== 'mount' || document.hidden) return;
    var m = new DOMMatrixReadOnly(getComputedStyle(assemblage).transform);
    sceneMontage.eclairer([m.m11,-m.m12,m.m13,-m.m21,m.m22,-m.m23,m.m31,-m.m32,m.m33], etape === 3);
    if (performance.now() < finMouvement) trameMontage = requestAnimationFrame(eclairerMontage);
  }

  function suivreMontage() {
    finMouvement = performance.now() + (priseMontage || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1100);
    if (!trameMontage) trameMontage = requestAnimationFrame(eclairerMontage);
  }

  function orienterMontage(x, y) {
    mx = Math.max(-20, Math.min(20, x));
    my = Math.max(0, Math.min(70, y));
    montage.style.setProperty('--mount-rx', mx + 'deg');
    montage.style.setProperty('--mount-ry', my + 'deg');
    angle.setAttribute('aria-pressed', String(my >= 65));
    suivreMontage();
  }

  function choisirEtape(n) {
    etape = n;
    montage.dataset.step = String(n);
    dialogue.querySelectorAll('[data-metal-step]').forEach(function (b) {
      if (Number(b.dataset.metalStep) === n) b.setAttribute('aria-current', 'step');
      else b.removeAttribute('aria-current');
    });
    dialogue.querySelectorAll('[data-metal-caption]').forEach(function (p) { p.hidden = Number(p.dataset.metalCaption) !== n; });
    dialogue.querySelectorAll('[data-metal-action]').forEach(function (s) { s.hidden = Number(s.dataset.metalAction) !== n; });
    orienterMontage(-8, 48);
  }

  function choisirMode(nom) {
    clearTimeout(delai);
    mode = nom;
    dialogue.dataset.mode = nom;
    montage.hidden = nom !== 'mount';
    commandesMontage.hidden = nom !== 'mount';
    commandesArt.hidden = nom !== 'art';
    dialogue.querySelectorAll('[data-metal-mode]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.metalMode === nom)); });
    if (nom === 'mount') {
      if (!imageMontage.getAttribute('src')) imageMontage.src = imageMontage.dataset.src;
      cadrerMontage();
      if (!sceneMontage && window.__displateMonter) {
        sceneMontage = window.__displateMonter(toileMontage, source.dataset.image, parseFloat(source.dataset.ratio) || 0.6923, { surface: true, visibilite: vueMontage });
      }
      suivreMontage();
    } else {
      initialiserArt();
    }
    etat(pretCourant, echecCourant);
  }

  function initialiserArt() {
    repli.src = repli.dataset.src;
    enveloppe.hidden = false;
    if (!scene && window.__displateMonter) {
      scene = window.__displateMonter(toile, source.dataset.image, parseFloat(source.dataset.ratio) || 0.6923, { exploration: true });
    }
    format();
    if (scene) {
      scene.geste(true);
      scene.incliner(-0.06, -0.06);
      etat(scene.ready(), false);
      if (!scene.ready()) delai = setTimeout(function () { etat(false, true); }, 12000);
    } else etat(false, true);
  }

  function format() {
    if (!scene) return;
    var choix = document.querySelector('.pdp-option [data-value][aria-pressed="true"]');
    var dimensions = choix && (choix.getAttribute('data-value') || '').match(/(\d+)\s*[x×]\s*(\d+)/i);
    if (dimensions) {
      var paysage = parseFloat(source.dataset.ratio) > 1;
      scene.format((paysage ? Math.min : Math.max)(Number(dimensions[1]), Number(dimensions[2])) * 10);
    } else scene.format(400);
  }

  var preparation = false, apercuUrl = null, imageOrigine = source.dataset.image;
  function montrer(e) {
    e.preventDefault(); e.stopPropagation();
    if (window.__pdpPersoMetal && window.__pdpMetalPreview && !preparation) {
      preparation = true;
      ouvrir.disabled = true;
      window.__pdpMetalPreview().then(function (p) {
        if (scene) scene.destroy();
        if (sceneMontage) sceneMontage.destroy();
        scene = sceneMontage = null;
        if (apercuUrl) URL.revokeObjectURL(apercuUrl);
        apercuUrl = p && p.image;
        source.dataset.image = apercuUrl || imageOrigine;
        if (p) source.dataset.ratio = String(p.ratio);
        repli.dataset.src = source.dataset.image;
        imageMontage.dataset.src = source.dataset.image;
        imageMontage.removeAttribute('src');
        montrer(e);
      }).catch(function () { montrer(e); }).finally(function () {
        preparation = false;
        ouvrir.disabled = false;
      });
      return;
    }
    if (dialogue.open) return;
    // Safari ne donne pas toujours le focus à un bouton activé au doigt.
    focusAvant = ouvrir;
    defilement = window.scrollY;
    corpsAvant = {};
    clesCorps.forEach(function (cle) { corpsAvant[cle] = document.body.style[cle]; });
    document.body.style.position = 'fixed';
    document.body.style.top = -defilement + 'px';
    document.body.style.left = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    dialogue.showModal();
    choisirEtape(0);
    choisirMode('mount');
  }

  function fermer() {
    clearTimeout(delai);
    cancelAnimationFrame(trameMontage); trameMontage = 0;
    finirMontage();
    if (scene) scene.geste(false);
    if (corpsAvant) {
      clesCorps.forEach(function (cle) { document.body.style[cle] = corpsAvant[cle]; });
      corpsAvant = null;
      window.scrollTo({ top: defilement, behavior: 'instant' });
    }
    if (focusAvant && focusAvant.isConnected) focusAvant.focus({ preventScroll: true });
  }

  ouvrir.addEventListener('click', montrer);
  var aide = document.querySelector('[data-metal-help]');
  if (aide) {
    aide.addEventListener('click', montrer);
    var afficherAide = function () { aide.hidden = document.documentElement.getAttribute('data-support') !== 'metal'; };
    new MutationObserver(afficherAide).observe(document.documentElement, { attributes: true, attributeFilter: ['data-support'] });
    afficherAide();
  }
  // Un appui sur le bouton 3D ne commence pas en même temps un glissement de galerie.
  ['pointerdown', 'touchstart'].forEach(function (nom) {
    ouvrir.addEventListener(nom, function (e) { e.stopPropagation(); }, { passive: true });
  });
  dialogue.querySelector('[data-metal-close]').addEventListener('click', function () { dialogue.close(); });
  dialogue.addEventListener('close', fermer);
  dialogue.addEventListener('click', function (e) { if (e.target === dialogue) dialogue.close(); });
  dialogue.querySelector('[data-metal-reset]').addEventListener('click', function () { if (scene) scene.recentrer(); });
  var directions = { left: [0,-0.26], right: [0,0.26], up: [0.20,0], down: [-0.20,0] };
  dialogue.querySelectorAll('[data-metal-turn]').forEach(function (b) {
    b.addEventListener('click', function () { if (scene) scene.tourner.apply(null, directions[b.dataset.metalTurn]); });
  });
  toile.addEventListener('af:metal-ready', function (e) {
    if (dialogue.open) etat(e.detail.ready, !e.detail.ready);
  });
  toile.addEventListener('af:metal-error', function () { if (dialogue.open) etat(false, true); });
  toileMontage.addEventListener('af:metal-ready', suivreMontage);
  document.addEventListener('visibilitychange', function () { if (!document.hidden && dialogue.open && mode === 'mount') suivreMontage(); });
  dialogue.querySelectorAll('[data-metal-mode]').forEach(function (b) {
    b.addEventListener('click', function () { choisirMode(b.dataset.metalMode); });
  });
  dialogue.querySelectorAll('[data-metal-step]').forEach(function (b) {
    b.addEventListener('click', function () { choisirEtape(Number(b.dataset.metalStep)); });
  });
  dialogue.querySelector('[data-metal-next]').addEventListener('click', function () { choisirEtape((etape + 1) % dialogue.querySelectorAll('[data-metal-step]').length); });
  angle.addEventListener('click', function () { orienterMontage(-8, my >= 65 ? 48 : 68); });
  new ResizeObserver(cadrerMontage).observe(stage);
  vueMontage.addEventListener('pointerdown', function (e) {
    if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
    e.preventDefault();
    vueMontage.focus({ preventScroll: true });
    priseMontage = { id: e.pointerId, x: e.clientX, y: e.clientY, rx: mx, ry: my };
    vueMontage.setPointerCapture(e.pointerId);
    vueMontage.dataset.dragging = 'true';
  });
  vueMontage.addEventListener('pointermove', function (e) {
    if (!priseMontage || e.pointerId !== priseMontage.id) return;
    orienterMontage(priseMontage.rx - (e.clientY - priseMontage.y) * .22, priseMontage.ry + (e.clientX - priseMontage.x) * .3);
  });
  function finirMontage() {
    if (priseMontage && vueMontage.hasPointerCapture(priseMontage.id)) vueMontage.releasePointerCapture(priseMontage.id);
    priseMontage = null;
    delete vueMontage.dataset.dragging;
  }
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (nom) { vueMontage.addEventListener(nom, finirMontage); });
  vueMontage.addEventListener('keydown', function (e) {
    var mouvement = { ArrowLeft: [0,-10], ArrowRight: [0,10], ArrowUp: [-8,0], ArrowDown: [8,0] }[e.key];
    if (mouvement) { e.preventDefault(); orienterMontage(mx + mouvement[0], my + mouvement[1]); }
    else if (e.key === 'Home') { e.preventDefault(); orienterMontage(0, 0); }
  });
})();
